import { Loader2 } from "lucide-react";
import * as React from "react";
import { forwardRef, useMemo, useState } from "react";

import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue
} from "../ui/select";

interface SearchDropdownProps<T> {
	field: any;
	data: T[] | undefined;
	isPending: boolean;
	diasbled?: boolean;
	isError: boolean;
	placeholder: string;
	searchPlaceholder: string;
	renderItem: (item: T) => React.ReactNode;
	filterFunction: (item: T, search: string) => boolean;
}

const SearchDropdown = forwardRef<HTMLSelectElement, SearchDropdownProps<any>>((props, ref) => {
	const [search, setSearch] = useState("");
	const filteredData = useMemo(
		() =>
			props.data
				? props.data.filter(item => props.filterFunction(item, search))
				: [],
		[props, search]
	);
	return (
		<div className="w-full space-y-4">
			<div>
				<Label htmlFor="name" className="text-right sr-only">
					{props.placeholder}
				</Label>
				<Select
					disabled={props.diasbled}
					onValueChange={value => props.field.onChange(value)}
					value={props.field.value}
				>
					<SelectTrigger className="w-full mt-2">
						<SelectValue
							ref={ref}
							placeholder={props.placeholder}
						/>
					</SelectTrigger>
					<SelectContent>
						<div className="p-2">
							{filteredData.length
								? (
										<Input
											placeholder={props.searchPlaceholder}
											value={search}
											onChange={e => setSearch(e.target.value)}
											className="mb-2"
										/>
									)
								: null}
							<SelectGroup className="grid place-items-center">
								{props.isPending
									? (
											<Loader2 size={20} className="animate-spin opacity-50" />
										)
									: props.isError
										? (
												<div>Error Fetching data</div>
											)
										: filteredData.length
											? (
													filteredData.map(item => (
														<SelectItem
															key={item.id}
															value={item.id.toString()}
															className="py-1"
														>
															{props.renderItem(item)}
														</SelectItem>
													))
												)
											: (
													<div className="mx-4 text-sm text-muted-foreground">
														No items available
													</div>
												)}
							</SelectGroup>
						</div>
					</SelectContent>
				</Select>
			</div>
		</div>
	);
});

export default SearchDropdown;
